
export default function TrustedBy() {
  const logos = [
    { name: 'Boeing', src: 'https://www.datalogics.com/endorsements/boeing_b.png' },
    { name: 'IBM', src: 'https://www.datalogics.com/endorsements/ibm_b.png' },
    { name: 'HP', src: 'https://www.datalogics.com/endorsements/hp_b.png' },
    { name: 'Oracle', src: 'https://www.datalogics.com/endorsements/oracle_b.png' },
    { name: 'SAP', src: 'https://www.datalogics.com/endorsements/sap_b.png' },
    { name: 'Siemens', src: 'https://www.datalogics.com/endorsements/siemens_b.png' },
    { name: 'Chase', src: 'https://www.datalogics.com/endorsements/chase_b.png' },
    { name: 'Fidelity', src: 'https://www.datalogics.com/endorsements/fidelity_b.png' },
    { name: 'OpenText', src: 'https://www.datalogics.com/endorsements/opentext_b.png' },
    { name: 'Real Life Sciences', src: 'https://www.datalogics.com/endorsements/reallifescience_b.png' },
    { name: 'RR Donnelley', src: 'https://www.datalogics.com/endorsements/rrd_b.png' },
    { name: 'Sealed Air', src: 'https://www.datalogics.com/endorsements/sealedair_b.png' },
    { name: 'DFIN', src: 'https://www.datalogics.com/endorsements/dfin_b.png' },
    { name: 'Callas Software', src: 'https://www.datalogics.com/endorsements/callas_b.png' },
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            受行业领导者信赖
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Datalogics在处理最新Adobe PDF规范方面提供无与伦比的准确性和可靠性。我们拥有91%的客户保留率是有原因的。
          </p>
        </div>
        <div className="hidden lg:flex lg:flex-col gap-16">
          <div className="flex justify-between items-center">
            {logos.slice(0, 7).map((logo) => (
              <div key={logo.name} className="w-[180px] group cursor-pointer">
                <img
                  src={logo.src}
                  alt={`${logo.name} logo`}
                  className="w-full h-auto object-contain max-h-[60px] transition-all duration-300 group-hover:scale-110 opacity-60 hover:opacity-100"
                />
              </div>
            ))}
          </div>
          <div className="flex justify-between items-center">
            {logos.slice(7).map((logo) => (
              <div key={logo.name} className="w-[180px] group cursor-pointer">
                <img
                  src={logo.src}
                  alt={`${logo.name} logo`}
                  className="w-full h-auto object-contain max-h-[60px] transition-all duration-300 group-hover:scale-110 opacity-60 hover:opacity-100"
                />
              </div>
            ))}
          </div>
        </div>
        <div className="block lg:hidden grid grid-cols-2 gap-12">
          {logos.map((logo) => (
            <div key={logo.name} className="group cursor-pointer">
              <img
                src={logo.src}
                alt={`${logo.name} logo`}
                className="w-full h-auto object-contain max-h-[40px] transition-all duration-300 group-hover:scale-110 opacity-60 hover:opacity-100"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
